module.exports = __webpack_public_path__ + "static/media/6.5abd9e13.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/6.png
// module id = 1327
// module chunks = 0